/**
 * A converted PDF arrives with its title as an `<h1>` at the top of the body,
 * sometimes after a logo. Returns that heading's text and the body without
 * it, or null when the body doesn't open with one: an `<h1>` after any words
 * is a section heading, not the document's title.
 */
export const splitLeadingTitle = (
  html: string,
): { title: string; body: string } | null => {
  const container = document.createElement("div");
  container.innerHTML = html;
  for (const element of Array.from(container.children)) {
    if (element.tagName === "H1") {
      const title = (element.textContent ?? "").replace(/\s+/g, " ").trim();
      if (!title) return null;
      element.remove();
      return { title, body: container.innerHTML };
    }
    // Images and empty blocks may come first; any text means the title
    // isn't at the top.
    if ((element.textContent ?? "").trim()) return null;
  }
  return null;
};
